import instance from "../../../config/axios";
import url from "../../../constants/url";

const order = "order";
const dispatch = "dispatch";
const grid = "schedules-grid";

// API call to get list from the endpoint
export const getSoftScheduleListApi = async (payload) => {
  return instance
    .post(`${url.packagingapiurl}${order}/${dispatch}/${grid}`, payload)
    .then((res) => {
      return res;
    });
};